module.exports = __webpack_public_path__ + "images/puzzle/Puzzle/PNG/Piece03.c0bc7a36e11a4250d19c9e4f6971bb36.png";